<template>
  <div class="tabsMenu">
    <div class="">
      <el-tabs
        v-model="editableTabsValue"
        type="card"
        editable
        @tab-click="getPath"
        @edit="handleTabsEdit"
        @contextmenu.prevent.native="tabItemsMenu($event)"
      >
        <el-tab-pane
          :key="item.name"
          v-for="(item, index) in editableTabs"
          :label="item.title"
          :name="item.name"
          :index="index"
        ></el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      editableTabsValue: '',
      editableTabs: []
    }
  },
  computed: {
    getRemoveTagName: function () {
      return this.$store.state.removeTagName
    }
  },
  watch: {
    '$route'(n, o) {
      var arr = this.editableTabs.filter(item => item.title === n.meta.title);
      if (!arr.length) {
        this.handleTabsEdit(n, 'add');
      } else {
        this.editableTabsValue = arr[0].name;
      }
      // 防止（doRemoveTag）不会出现变化
      setTimeout(() => {
        this.$store.commit('doRemoveTag', '');
      }, 3000)
    },
    getRemoveTagName(val) {
      if (val) {
        var arr = JSON.parse(JSON.stringify(this.editableTabs));
        this.editableTabs = arr.filter(item => item.name !== val);
      }
    }
  },
  created() {
    var route = this.$route;
    this.handleTabsEdit(route, 'add');
  },
  methods: {
    handleTabsEdit(targetName, action) {
      // console.log(action, '====')
      if (action === 'add') {
        this.editableTabs.push({
          title: targetName.meta.title,
          name: targetName.path,
          content: targetName.path
        });
        this.editableTabsValue = targetName.path;
      }
      if (action === 'remove') {
        // console.log(targetName, '===', this.editableTabsValue)
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        if (tabs.length === 1) {
          this.$router.push('/home')
        } else {
          this.$router.push(activeName)
        }
        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      }
    },
    getPath(aa) {
      this.$router.push(aa.name);
    },
    /**
     * tab右键按钮操作
     * 
     * @param {*} event 
     */
    tabItemsMenu(event) {
      let clickTab;
      if (event.srcElement.id) {
        // 获取点击的tab
        clickTab = event.srcElement.id;
      }
      if (!clickTab) {
        // 未选中tab，无须显示右键按钮
        return;
      }
      let clickTabName = clickTab.replace('tab-', '');
      
      // 处理按钮是否可以操作
      let disableLeftBtn = false,  disableRightBtn = false, disableOtherBtn = false, disableAllBtn = false;
      let length = this.editableTabs.length;
      if (length == 1) {
        // 如果只有一个tab，那么右键按钮都不可用
        disableLeftBtn = disableRightBtn = disableOtherBtn = disableAllBtn = true;
      } else {
        // 当前点击的tab所在位置
        let index = this.editableTabs.findIndex(item => {return item.name === clickTabName});
        if (index == 0) {
          // 如果选择第一个，关闭左侧设置不可用
          disableLeftBtn = true;
        } else if (index == length - 1) {
          // 如果选择最后一个，关闭右侧设置不可用
          disableRightBtn = true;
        }
      }
      
      const items = {
        items: [
          {
            label: '关闭左侧',
            icon: 'el-icon-d-arrow-left',
            disabled: disableLeftBtn,
            divided: true,
            onClick: () => {
              this.closeTabs('closeLeft', clickTabName);
            }
          },
          {
            label: '关闭右侧',
            icon: 'el-icon-d-arrow-right',
            disabled: disableRightBtn,
            divided: true,
            onClick: () => {
              this.closeTabs('closeRight', clickTabName);
            }
          },
          {
            label: '关闭其他',
            icon: 'el-icon-circle-close',
            disabled: disableOtherBtn,
            divided: true,
            onClick: () => {
              this.closeTabs('closeOther', clickTabName);
            }
          },
          {
            label: '关闭全部',
            icon: 'el-icon-error',
            disabled: disableAllBtn,
            divided: true,
            onClick: () => {
              this.closeTabs('closeAll', '');
            }
          },
        ],
        customClass: 'custom-class',
        event: event,
        zIndex: 9999
      }
      this.$contextmenu(items)
      return false
    },
    closeTabs(code, clickTabName) {
      if ('closeLeft' == code || 'closeRight' == code) {
        let hintIndex = this.editableTabs.findIndex(item => {return item.name === clickTabName});
        if ('closeLeft' == code) {
          // 关闭左侧
          this.editableTabs.splice(0, hintIndex);
        } else {
          // 关闭右侧
          this.editableTabs.splice(hintIndex + 1);
        }
        
        // 判断打开的菜单是否在被关闭菜单中，如果是，则获取最后一个tab，并设置为打开菜单
        let hinteditTabIndex = this.editableTabs.findIndex(item => {return item.name === this.editableTabsValue});
        if (hinteditTabIndex < 0) {
          let lastTab = this.editableTabs.slice(-1);
          this.editableTabsValue = lastTab[0].name;
          this.$router.push(lastTab[0].name);
        }
        
      } else if ('closeOther' == code) {
        // 关闭其他
        let tabs = this.editableTabs;
        this.editableTabs = tabs.filter(tab => tab.name === clickTabName);
        this.editableTabsValue = clickTabName;
        this.$router.push(clickTabName);
        
      } else if ('closeAll' == code) {
        // 关闭全部
        this.editableTabs = [];
        this.editableTabsValue = '/home';
        this.$router.push('/home');
        
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.tabsMenu {
  height: 50px;
  background: #FFF;
  color: #fff;
  box-shadow: 5px 5px 5px -5px rgba(0,0,0,0.17);
  padding: 0 7px;
  .tabs {
    // width: 90%;
    max-width: 100%;
    min-width: 1200px;
    margin: auto;
    padding: 12px 0;
  }
}
.tabsMenu /deep/ .el-tabs__new-tab{
  display: none;
}
.tabsMenu /deep/ .el-tabs__nav-next{
  top: 7px;
}
.tabsMenu /deep/ .el-icon-close{
  padding-left: 0;
  padding-right: 12px;
  right: 0!important;
  transition: none;
}
.tabsMenu /deep/ .el-tabs--card>.el-tabs__header .el-tabs__item:first-child{
  border-bottom: none;
}
</style>
<style lang="scss">
/* custom conetxt menu */
.custom-class {
  min-width: 90px !important;
  max-width: 160px;

  // .menu_item__available:hover,
  // .menu_item_expand {
  //   background: #ffecf2 !important;
  //   color: #ff4050 !important;
  // }

  .menu_item_expand_icon {
    display: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/tabs/index.vue